<template>
  <div class="validation-component flex flex-col gap-1">
    <slot />

    <div
      :class="{
        'sr-only': !(errors && errors.length),
      }"
      role="status"
    >
      <div
        v-for="e in errors"
        :key="e"
        class="error-text"
        :style="(width && { marginLeft: width, paddingLeft: '5px' }) || {}"
      >
        {{ e }}
      </div>
    </div>

    <div v-if="$slots.actions || actions" class="form-actions" :class="{ left: actionsLeft }">
      <slot name="actions">
        <m-action :model-value="actions" ghost />
      </slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import MAction, { ActionModelValue } from "../../MAction";

defineProps<{
  errors?: string[];
  width?: string;

  actions?: ActionModelValue;
  actionsLeft?: boolean;

  // prevent attrs fallthrough
  disabled?: boolean;
}>();
</script>
<style lang="scss">
.validation-component {
  .error-text {
    margin: 0;
  }

  .form-actions {
    display: flex;

    align-items: flex-end;
    justify-content: flex-end;

    &.left {
      justify-content: flex-start;
    }
  }
}
</style>
